/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 0 = Insurance
 *
 * 1 = Company
 *
 * 2 = Employee
 */
export enum AccidentVehiclePaymentType {
  Insurance = 0,
  Company = 1,
  Employee = 2,
}
